import React, { Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Spinner,
  Progress,
  Table,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Select from "../../../../helpers/ui/CustomSelect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvField,
  AvGroup,
  AvCheckboxGroup,
  AvCheckbox,
  AvInput,
} from "availity-reactstrap-validation";
import { Preview } from "../../../../helpers/ui/FileInput";

import { Redirect, Link } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";
import { cancelToken } from "../../../../services/adapters/kepegawaian/menuService";

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import UpdateBloc from "./Blocs/UpdateBloc";
import RiwayatNikahBloc from "../Index/Blocs/RiwayatNikahBloc";
import { accessRole } from "../../../../helpers/access_role";
import IndexBloc from "../Index/Blocs/IndexBloc";
import DatePicker from "../../../../helpers/ui/DatePicker";

const jobType = [
  { value: 1, label: "PNS BKPM" },
  { value: 2, label: "PNS Non BKPM" },
  { value: 3, label: "Non PNS" },
  { value: 4, label: "Belum Bekerja" },
];

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

var reformatOptionPendidikan = function (award) {
  return award.map((value, index) => {
    var newObj = {};
    newObj["label"] = value.education_name;
    newObj["value"] = value.education_uuid;

    return newObj;
  });
};

var reformatOptionsCouple = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];
    newObj["model"] = data;

    return newObj;
  });
};

class UpdateView extends Component {
  source;
  updateBloc = new UpdateBloc();
  riwayatBloc = new RiwayatNikahBloc();
  indexBloc = new IndexBloc();
  defaultSize = 10;

  currentRoleId = JSON.parse(localStorage.getItem("currentRoleId"));

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_uuid
      : "";

  peg_nip = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_nip
      : ""
    : this.employeeSeleted != null
      ? this.employeeSeleted.employee_nip
      : "";

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      detail: [],
      pendidikanOption: [],
      statusOption: [],
      pnsStatus: null,
      ahliWaris: false,
      isPay: false,
      statusNikah: "5d288dc0-44f7-4b4e-a633-bdea6481205f",
      pendidikanFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: "education_code",
          order: "asc",
        },
      },
      birthOptionNationality: [
        { label: "Dalam Negeri", value: "Dalam Negeri" },
        { label: "Luar Negeri", value: "Luar Negeri" },
      ],
      birthOptionProvince: [],
      birthOptionCity: [],
      birthOptionCountry: [],
      birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
      isLocal: 1,
      selectedDocType: null,
      selectedDocLabel: null,
      optionCouples: [],
      selectedCouple: null,
      selectedCoupleUuid: null,
      satkerGajiwebOption: [],
      couple_name: "",
    };
  }

  // Select Area

  handleBirthSelectNationality = (birthSelectNationality) => {
    let selected = birthSelectNationality.value;
    if (selected == "Dalam Negeri") {
      this.setState({
        birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
        isLocal: 1,
      });
    } else {
      this.setState({
        birthSelectedCountry: "",
        isLocal: 0,
      });
    }
  };

  handleBirthSelectCountry = (birthSelectedCountry) => {
    let selected = birthSelectedCountry.value;
    this.getBirthProvinceByCountry(selected);
  };

  getBirthProvinceByCountry(selected_uuid) {
    this.updateBloc.fetchRegionProvince({
      //is_local: 1,
      parent_uuid: selected_uuid,
      type: 2,
    });
  }

  handleBirthSelectProvince = (birthSelectedProvince) => {
    let selected = birthSelectedProvince.value;
    this.getBirthCityByProvince(selected);
  };

  getBirthCityByProvince = (province_uuid) => {
    this.updateBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  // select

  titleCase = (s) =>
    s.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
      c ? c.toUpperCase() : " " + d.toUpperCase(),
    );

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, "document");
    await this.updateBloc.fetchUpdate(formData);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        id: this.props.id,
        employee_uuid: this.peg_uuid,
        ...values,
        statusTunjangan: Number(values.statusTunjangan),
      },
      confirm: true,
    });
  };

  loadPendidikan = async () => {
    let offset =
      (this.state.pendidikanFilter.page_number - 1) *
      this.state.pendidikanFilter.page_size;
    const query = {
      search: this.state.pendidikanFilter.filter_value,
      limit: this.state.pendidikanFilter.page_size,
      offset: offset,
      order: this.state.pendidikanFilter.sort_order.column,
      sort: this.state.pendidikanFilter.sort_order.order,
      status: 1,
    };
    await this.riwayatBloc.fetchPendidikan(query, this.source.token);
  };

  loadStatus = async () => {
    const query = {};

    await this.indexBloc.fetchStatus(query, this.source.token);
  };

  loadDetail = async () => {
    const query = {
      id: this.props.id,
    };
    await this.updateBloc.fetchDetail(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadPendidikan();
    this.loadStatus();
    this.loadDetail();
  };

  handlePendidikanInputChange = (inputValue, actionMeta) => {
    if (inputValue !== "") {
      this.state.pendidikanFilter.filter_value = inputValue;
      this.loadPendidikan();
    }
  };

  componentDidMount() {
    this.setTokenAPI();

    this.riwayatBloc.pendidikanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            pendidikanOption: reformatOptionPendidikan(
              result.data.response.result,
            ),
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.statusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ statusOption: result.data.response });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            detail: result.data.response,
            pnsStatus: Number(
              result.data.response.family.family_spouse_job_type,
            ),
            ahliWaris:
              result.data.response.family.family_spouse_is_heir == 1
                ? true
                : false,
            isPay:
              result.data.response.family.family_spouse_is_pay == 1
                ? true
                : false,
            statusNikah:
              result.data.response.family.family_relationship_status_uuid,
            birthSelectedCountry:
              result.data.response.family.family_place_of_birth_country_uuid,
            documents: result.data.response?.family.documents,
            selectedCoupleUuid:
              result.data.response.family.family_couple_employee_uuid,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    // get data birth country
    this.updateBloc.regionCountryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCountry: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.updateBloc.fetchRegionCountry({
      type: 1,
    });

    // get data birth province
    this.updateBloc.regionProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

    // get data city where province selected
    this.updateBloc.regionCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid",
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.getBirthCityByProvince(
      this.dataForm ? this.dataForm.place_of_birth_province_uuid : "",
    );

    this.updateBloc.coupleChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            const options = reformatOptionsCouple(
              result.data.response,
              "employee_name",
              "employee_uuid",
            );

            this.setState({
              optionCouples: options,
              selectedCouple:
                options.find(
                  (o) => o.value === this.state.selectedCoupleUuid,
                ) || null,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.fetchCouple({
      employee_uuid: this.peg_uuid,
    });

    this.updateBloc.satkerGajiWebChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const employeeData = result?.data?.response?.data?.decryptData?.[0];

          this.setState({
            satkerGajiwebOption: employeeData || {},
            loadingSatkerGajiWeb: false,
          });

          break;

        case apiResponse.ERROR:
          this.setState({
            loadingSatkerGajiWeb: false,
          });
          break;

        default:
          break;
      }
    });
    this.updateBloc.fetchSatkerGajiWeb({
      nip: this.peg_nip,
    });
  }

  componentWillUnmount() {
    this.indexBloc.pendidikanChannel?.unsubscribe();
    this.updateBloc.updateChannel?.unsubscribe();
    this.updateBloc.detailChannel?.unsubscribe();
    this.updateBloc.coupleChannel?.unsubscribe();
    this.updateBloc.satkerGajiWebChannel?.unsubscribe();
  }

  render() {
    const { detail, family } = this.state.detail;

    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <PegawaiSideBar active="riwayat_nikah" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <div className="float-end">
                    <Link to={`?riwayat_nikah`}>
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Update Data Suami/Istri</CardTitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    {family?.family_status == 2 ? (
                      <Row className="mb-3">
                        <Col md="12">
                          <div
                            class="alert-dismissible fade show alert alert-danger alert-dismissible fade show"
                            role="alert"
                          >
                            <button
                              type="button"
                              class="close"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">×</span>
                            </button>
                            <i class="uil uil-exclamation-octagon me-2"></i>{" "}
                            Catatan Approval :{" "}
                            {family?.family_status_description}
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                    <Row>
                      <Col md="6">
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldJobType"
                            className="col-md-3 col-form-label"
                          >
                            Jenis Pekerjaan :
                          </Label>
                          <Col md="4">
                            <Select
                              name="jobType"
                              options={jobType}
                              isSearchable={false}
                              onChange={(opt) =>
                                this.setState({
                                  pnsStatus: Number(opt.value),
                                })
                              }
                              defaultValue={this.state.pnsStatus}
                            />
                          </Col>
                        </Row>

                        {(this.state.pnsStatus === 1 ||
                          this.state.pnsStatus === 2) && (
                          <>
                            <Row className="mb-3">
                              <Label
                                htmlFor="fieldNIP"
                                className="col-md-3 col-form-label"
                              >
                                NIP :{" "}
                              </Label>
                              <Col md="8">
                                <AvField
                                  name="nip"
                                  placeholder="NIP..."
                                  errorMessage="Masukkan NIP"
                                  type="number"
                                  className="form-control"
                                  id="fieldNIP"
                                  value={family?.family_profession_pns_nip}
                                  validate={{ required: { value: true } }}
                                />
                              </Col>
                            </Row>

                            {this.state.pnsStatus !== 1 && (
                              <Row className="mb-3">
                                <Label className="col-md-3 col-form-label"></Label>
                                <Col md="8" style={{ paddingTop: "8px" }}>
                                  <AvInput
                                    type="checkbox"
                                    name="statusTunjangan"
                                    id="fieldStatusTunjangan"
                                    defaultChecked={Boolean(
                                      family?.family_is_dependent_allowance,
                                    )}
                                  />
                                  <span style={{ marginLeft: "8px" }}>
                                    Apakah pasangan sudah dapat tunjangan
                                    keluarga di tempat lain? (jika ya, centang
                                    kotak ini)
                                  </span>
                                </Col>
                              </Row>
                            )}
                          </>
                        )}

                        {this.state.pnsStatus == 3 && (
                          <>
                            <Row className="mb-3">
                              <label
                                htmlFor="profession"
                                className="col-md-3 col-form-label"
                              >
                                Pekerjaan <span className="text-danger">*</span>
                              </label>
                              <Col md="5">
                                <AvField
                                  name="profession"
                                  placeholder="Pekerjaan..."
                                  type="text"
                                  errorMessage="Masukkan Pekerjaan"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="profession"
                                  value={family?.family_profession}
                                />
                              </Col>
                            </Row>
                          </>
                        )}

                        {this.state.pnsStatus === 1 && (
                          <Row className="mb-3">
                            <label className="col-md-3 col-form-label">
                              Nama Suami/Istri :
                            </label>

                            <Col md="8">
                              <Select
                                name="family_couple_employee_uuid"
                                options={this.state.optionCouples}
                                placeholder="Pilih Nama Pasangan"
                                defaultValue={
                                  this.state.detail?.family
                                    ?.family_couple_employee_uuid
                                }
                                onChange={(v) =>
                                  this.setState({
                                    selectedCoupleUuid: v.value,
                                    selectedEmployee: v.model,
                                    couple_name: v.label,
                                  })
                                }
                              />
                              <AvField
                                type="hidden"
                                name="couple_name"
                                value={
                                  this.state.couple_name ||
                                  this.state.detail?.family?.family_name
                                }
                              />
                            </Col>
                          </Row>
                        )}

                        {this.state.pnsStatus !== 1 && (
                          <Row className="mb-3">
                            <Label
                              htmlFor="fieldSpouse"
                              className="col-md-3 col-form-label"
                            >
                              Nama Suami/Istri :{" "}
                            </Label>
                            <Col md="8">
                              <AvField
                                name="spouse"
                                placeholder="Suami/Istri..."
                                errorMessage="Masukkan Nama Suami/Istri"
                                type="name"
                                className="form-control"
                                id="fieldSpouse"
                                value={family?.family_name}
                                validate={{ required: { value: true } }}
                              />
                            </Col>
                          </Row>
                        )}

                        <Row className="mb-3">
                          <label className="col-md-3 col-form-label">
                            Nomor Induk Kependudukan
                          </label>
                          <Col md="5">
                            <AvField
                              name="family_identity_number"
                              placeholder="Nomor Induk Kependudukan..."
                              type="text"
                              errorMessage="Masukkan Nomor Induk Kependudukan"
                              className="form-control"
                              id="family_identity_number"
                              value={family?.family_identity_number}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <label className="col-md-3 col-form-label">
                            Nomor Kartu Keluarga
                          </label>
                          <Col md="4">
                            <AvField
                              name="familty_family_card_number"
                              placeholder="Nomor Kartu Keluarga..."
                              type="text"
                              errorMessage="Masukkan Nomor Kartu Keluarga"
                              className="form-control"
                              id="familty_family_card_number"
                              value={family?.familty_family_card_number}
                            />
                          </Col>
                        </Row>

                        {/* <Row className="mb-3">
                                                    <Label htmlFor="fieldTempatLahir" className="col-md-3 col-form-label">Tempat Lahir : </Label>
                                                    <Col md="8">
                                                        <AvField
                                                            name="tempatLahir"
                                                            placeholder="Tempat Lahir..."
                                                            errorMessage="Masukkan Nama Tempat Lahir"
                                                            type="name"
                                                            className="form-control"
                                                            id="fieldTempatLahir"
                                                            value={family?.family_place_of_birth_city_text}
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row> */}
                        <hr />
                        <Row>
                          <Col md="5">
                            <label className="fw-bold">#Tempat Lahir</label>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <label
                            htmlFor="tempat_lahir"
                            className="col-md-3 col-form-label"
                          >
                            Dalam / Luar Negeri{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <Select
                              name="place_of_birth_national"
                              errorMessage="Pilih Dalam / Luar Negeri Lahir"
                              onChange={this.handleBirthSelectNationality}
                              options={this.state.birthOptionNationality}
                              validate={{ required: { value: true } }}
                              placeholder="Pilih Dalam / Luar Negeri Lahir"
                              defaultValue={
                                family?.family_place_of_birth_national
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <label
                            htmlFor="tempat_lahir"
                            className="col-md-3 col-form-label"
                          >
                            Negara <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <Select
                              name="place_of_birth_country_uuid"
                              errorMessage="Pilih Negara Lahir"
                              onChange={this.handleBirthSelectCountry}
                              options={this.state.birthOptionCountry}
                              validate={{ required: { value: true } }}
                              placeholder="Pilih Negara Lahir"
                              defaultValue={this.state.birthSelectedCountry}
                            />
                          </Col>
                        </Row>

                        <Row
                          className="mb-3"
                          style={
                            this.state.isLocal == 0 ? { display: "none" } : {}
                          }
                        >
                          <label
                            htmlFor="tempat_ahir"
                            className="col-md-3 col-form-label"
                          >
                            Provinsi <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <Select
                              name="birth_province_uuid"
                              errorMessage="Pilih Provinsi Lahir"
                              onChange={this.handleBirthSelectProvince}
                              options={this.state.birthOptionProvince}
                              validate={{
                                required: {
                                  value: this.state.isLocal == 0 ? false : true,
                                },
                              }}
                              placeholder="Pilih Provinsi Lahir"
                              defaultValue={
                                family?.family_place_of_birth_province_uuid
                              }
                            />
                          </Col>
                        </Row>

                        <Row
                          className="mb-3"
                          style={
                            this.state.isLocal == 0 ? { display: "none" } : {}
                          }
                        >
                          <label
                            htmlFor="tempat_ahir"
                            className="col-md-3 col-form-label"
                          >
                            Kota <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <Select
                              name="place_of_birth_city_uuid"
                              errorMessage="Pilih Kota Lahir"
                              options={this.state.birthOptionCity}
                              validate={{
                                required: {
                                  value: this.state.isLocal == 0 ? false : true,
                                },
                              }}
                              placeholder="Pilih Kota Lahir"
                              defaultValue={
                                family?.family_place_of_birth_city_uuid
                              }
                            />
                          </Col>
                        </Row>

                        <Row
                          className="mb-3"
                          style={
                            this.state.isLocal == 1 ? { display: "none" } : {}
                          }
                        >
                          <label
                            htmlFor="place_of_birth_city_text"
                            className="col-md-3 col-form-label"
                          >
                            Kota <span className="text-danger">*</span>
                          </label>
                          <Col md="5">
                            <AvField
                              name="place_of_birth_city_text"
                              placeholder="Kota..."
                              type="text"
                              errorMessage="Masukkan Kota"
                              className="form-control"
                              validate={{
                                required: {
                                  value: this.state.isLocal == 1 ? false : true,
                                },
                              }}
                              id="place_of_birth_city_text"
                              value={family?.family_place_of_birth_city_text}
                            />
                          </Col>
                        </Row>

                        <hr />
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldTglLahir"
                            className="col-md-3 col-form-label"
                          >
                            Tanggal Lahir :{" "}
                          </Label>
                          <Col md="4">
                            {/* <AvField
                                                            name="tglLahir"
                                                            placeholder="Tanggal Lahir..."
                                                            errorMessage="Masukkan Tanggal Lahir"
                                                            type="date"
                                                            className="form-control"
                                                            id="fieldTglLahir"
                                                            value={family?.family_date_of_birth}
                                                            validate={{ required: { value: true } }}
                                                        /> */}
                            <DatePicker
                              name={`tglLahir`}
                              isWeekday={false}
                              dateFormat="dd/MM/yyyy"
                              errorMessage="Masukan Tanggal Lahir"
                              validate={{ required: { value: true } }}
                              defaultValue={family?.family_date_of_birth}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldStatus"
                            className="col-md-3 col-form-label"
                          >
                            Status Nikah :{" "}
                          </Label>
                          <Col md="4">
                            <Select
                              options={this.state.statusOption}
                              name="status"
                              isSearchable={false}
                              optionValue="family_relationship_status_uuid"
                              optionLabel="family_relationship_status_name"
                              defaultValue={
                                family?.family_relationship_status_uuid
                              }
                              onChange={(opt) =>
                                this.setState({
                                  statusNikah:
                                    opt.family_relationship_status_uuid,
                                })
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldPendidikan"
                            className="col-md-3 col-form-label"
                          >
                            Pendidikan :{" "}
                          </Label>
                          <Col md="8">
                            <Select
                              name="pendidikan"
                              errorMessage="Pilih Jenis Pendidikan"
                              options={this.state.pendidikanOption}
                              placeholder="Pilih Jenis Pendidikan"
                              defaultValue={family?.family_education_uuid}
                              onInputChange={this.handlePendidikanInputChange}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldJurusan"
                            className="col-md-3 col-form-label"
                          >
                            Jurusan :{" "}
                          </Label>
                          <Col md="8">
                            <AvField
                              name="jurusan"
                              placeholder="Jurusan..."
                              errorMessage="Masukkan Nama Jurusan"
                              type="name"
                              className="form-control"
                              value={family?.family_major}
                              id="fieldJurusan"
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldTempatKerja"
                            className="col-md-3 col-form-label"
                          >
                            Tempat Kerja :{" "}
                          </Label>
                          <Col md="8">
                            <AvField
                              name="tempatKerja"
                              placeholder="Tempat Kerja..."
                              errorMessage="Masukkan Nama Tempat Kerja"
                              type="name"
                              className="form-control"
                              value={family?.family_profession_place}
                              id="fieldTempatKerja"
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldPekerjaan"
                            className="col-md-3 col-form-label"
                          >
                            Pekerjaan :{" "}
                          </Label>
                          <Col md="8">
                            <AvField
                              name="pekerjaan"
                              placeholder="Pekerjaan..."
                              errorMessage="Masukkan Nama Pekerjaan"
                              type="name"
                              className="form-control"
                              value={family?.family_profession}
                              id="fieldPekerjaan"
                            />
                          </Col>
                        </Row>

                        {this.currentRoleId == 1 && (
                          <Row className="mb-3">
                            <Label
                              htmlFor="fieldAhliWaris"
                              className="col-md-3 col-form-label"
                            >
                              Sebagai Ahli Waris :{" "}
                            </Label>
                            <Col md="8" style={{ paddingTop: "8px" }}>
                              <AvInput
                                type="checkbox"
                                name="ahliWaris"
                                className="form-label"
                                id="fieldAhliWaris"
                                defaultChecked={this.state.ahliWaris}
                                onChange={(e) =>
                                  this.setState({ ahliWaris: e.target.checked })
                                }
                              />
                            </Col>
                          </Row>
                        )}

                        {this.state.ahliWaris && (
                          <Fragment>
                            <Row className="mb-3">
                              <Label
                                htmlFor="fieldSudahDibayar"
                                className="col-md-3 col-form-label"
                              >
                                Sudah Dibayar :{" "}
                              </Label>
                              <Col md="8" style={{ paddingTop: "8px" }}>
                                <AvInput
                                  type="checkbox"
                                  name="sudahDibayar"
                                  className="form-label"
                                  id="fieldSudahDibayar"
                                  defaultChecked={this.state.isPay}
                                  onChange={(e) =>
                                    this.setState({ isPay: e.target.checked })
                                  }
                                />
                              </Col>
                            </Row>
                            {this.state.isPay && (
                              <Row className="mb-3">
                                <Label
                                  htmlFor="fieldBulanDibayar"
                                  className="col-md-3 col-form-label"
                                >
                                  Bulan Dibayar :{" "}
                                </Label>
                                <Col md="8">
                                  <AvField
                                    name="bulanDibayar"
                                    placeholder="Bulan Dibayar..."
                                    type="date"
                                    className="form-control"
                                    id="fieldBulanDibayar"
                                    value={family?.family_spouse_pay_date}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Fragment>
                        )}
                      </Col>

                      <Col md="6">
                        <CardTitle>Keterangan Nikah</CardTitle>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldNikahKe"
                            className="col-md-3 col-form-label"
                          >
                            Nikah Ke :{" "}
                          </Label>
                          <Col md="4">
                            <AvField
                              name="nikahKe"
                              placeholder="Nikah Ke..."
                              errorMessage="Masukkan Nama Pekerjaan"
                              type="name"
                              className="form-control"
                              id="fieldNikahKe"
                              value={family?.family_spouse_marriage_count}
                              validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldTglNikah"
                            className="col-md-3 col-form-label"
                          >
                            Tanggal Nikah :{" "}
                          </Label>
                          <Col md="4">
                            {/* <AvField
                                                            name="tglNikah"
                                                            placeholder="Tanggal Nikah..."
                                                            errorMessage="Masukkan Tanggal Nikah"
                                                            type="date"
                                                            className="form-control"
                                                            id="fieldTglNikah"
                                                            value={family?.family_spouse_wedding_date}
                                                            validate={{ required: { value: true } }}
                                                        /> */}
                            <DatePicker
                              name={`tglNikah`}
                              isWeekday={false}
                              dateFormat="dd/MM/yyyy"
                              errorMessage="Masukan Tanggal Nikah"
                              validate={{ required: { value: true } }}
                              defaultValue={family?.family_spouse_wedding_date}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldSpouseNo"
                            className="col-md-3 col-form-label"
                          >
                            Suami/Istri ke :{" "}
                          </Label>
                          <Col md="2">
                            <AvField
                              name="spouseNo"
                              errorMessage="Masukkan Urutan Pasangan"
                              type="number"
                              className="form-control"
                              id="fieldSpouseNo"
                              value={family?.family_spouse_husband_or_wife_to}
                              validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldBukuNikah"
                            className="col-md-3 col-form-label"
                          >
                            No Buku/Akta Nikah :{" "}
                          </Label>
                          <Col md="8">
                            <AvField
                              name="bukuNikah"
                              errorMessage="Masukkan No Buku/Akta Nikah"
                              type="text"
                              className="form-control"
                              id="fieldBukuNikah"
                              value={family?.family_spouse_marriage_book_number}
                              validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        {/* <Row className="mb-3">
                                                    <Label htmlFor="fieldsKartuNikah" className="col-md-3 col-form-label">Kartu Nikah : </Label>
                                                    <Col md="8">
                                                        <AvField
                                                            name="kartuNikah"
                                                            errorMessage="Masukkan Kartu Nikah"
                                                            type="text"
                                                            className="form-control"
                                                            id="fieldKartuNikah"
                                                            value={family?.family_spouse_wedding_card}
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row> */}
                        <hr />

                        {this.state.statusNikah !=
                          "5d288dc0-44f7-4b4e-a633-bdea6481205f" && (
                          <Fragment>
                            <CardTitle>Keterangan Cerai</CardTitle>
                            <Row className="mb-3">
                              <Label
                                htmlFor="fieldTanggalCerai"
                                className="col-md-3 col-form-label"
                              >
                                Tanggal Cerai :{" "}
                              </Label>
                              <Col md="4">
                                <AvField
                                  name="tglCerai"
                                  errorMessage="Masukkan Tanggal Cerai"
                                  type="date"
                                  className="form-control"
                                  value={family?.family_spouse_divorce_date}
                                  id="fieldTanggalCerai"
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Label
                                htmlFor="fieldSKCerai"
                                className="col-md-3 col-form-label"
                              >
                                No SK Cerai :{" "}
                              </Label>
                              <Col md="8">
                                <AvField
                                  name="skCerai"
                                  errorMessage="Masukkan No SK Cerai"
                                  type="text"
                                  className="form-control"
                                  value={
                                    family?.family_spouse_divorce_number_decree
                                  }
                                  id="fieldSKCerai"
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Label
                                htmlFor="fieldTMTCerai"
                                className="col-md-3 col-form-label"
                              >
                                TMT SK Cerai :{" "}
                              </Label>
                              <Col md="4">
                                <AvField
                                  name="TMTCerai"
                                  errorMessage="Masukkan TMT SK Cerai"
                                  type="date"
                                  className="form-control"
                                  value={family?.family_spouse_divorce_tmt_date}
                                  id="fieldTMTCerai"
                                />
                              </Col>
                            </Row>
                            <hr />
                          </Fragment>
                        )}

                        <Row className="mb-3">
                          <Label
                            htmlFor="fieldKaris"
                            className="col-md-3 col-form-label"
                          >
                            No Karis / Karsu :{" "}
                          </Label>
                          <Col md="8">
                            <AvField
                              name="karis"
                              errorMessage="Masukkan No Karis / Karsu"
                              type="text"
                              className="form-control"
                              id="fieldKaris"
                              value={family?.family_spouse_karis_karsu_number}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <label
                            htmlFor="status"
                            className="col-md-3 col-form-label"
                          >
                            Jenis Dokumen <span className="text-danger">*</span>
                          </label>
                          <Col md="8">
                            <Select
                              name="family_document_type"
                              errorMessage="Pilih Jenis Dokumen"
                              options={[
                                {
                                  value: "file_buku_nikah",
                                  label: "Buku Nikah",
                                },
                                {
                                  value: "file_akta_cerai",
                                  label: "Akta Cerai",
                                },
                              ]}
                              onChange={(v) => {
                                this.setState({
                                  selectedDocType: v.value,
                                  selectedDocLabel: v.label,
                                });
                              }}
                              validate={{ required: { value: true } }}
                              placeholder="Pilih Jenis Dokumen"
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Upload Dokumen ({this.state.selectedDocLabel})
                            :{" "}
                          </Label>
                          <Col md="8">
                            <FileInput name="document" col="6" />
                          </Col>
                        </Row>

                        {/* <Row className="mb-3">
                                                    <Label className="col-md-3 col-form-label">File Sebelumnya</Label>
                                                    <Col md="8">
                                                        <Preview value={family?.document } />
                                                    </Col>
                                                </Row> */}

                        <hr />

                        {this.state.documents?.map((val, i) => {
                          return (
                            <Row className="mb-3">
                              <label className="col-md-3">
                                {this.titleCase(val.family_document_type)}
                              </label>
                              <Col md="9">
                                {val.document ? (
                                  <Preview value={val.document} />
                                ) : (
                                  <Shimmer>
                                    <div
                                      style={{ width: 68, height: 15 }}
                                    ></div>
                                  </Shimmer>
                                )}
                              </Col>
                            </Row>
                          );
                        })}
                      </Col>
                    </Row>
                    <hr />

                    <Row className="mb-3">
                      <Col md="4"></Col>
                      <Col md="8">
                        <Link to="/kepegawaian/home.html?riwayat_nikah">
                          <Button color="danger" type="button">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>

                    <Row>
                      {/* <AvField
                        type="hidden"
                        name="employee_satker_code"
                        value={this.state.satkerGajiwebOption?.kdsatker}
                      /> */}
                      <AvField
                        type="hidden"
                        name="employee_nip"
                        value={this.peg_nip}
                      />
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/home.html?riwayat_nikah" />
        ) : null}
      </Fragment>
    );
  }
}

export default UpdateView;
